"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionMark = QuestionMark;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const QuestionMarkCircle = styled_components_1.default.span `
	color: white;
	cursor: ${props => (props.pointer ? 'pointer' : 'default')};
	width: 20px;
	height: 20px;
	background-color: ${({ theme }) => theme.color.brand1};
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
`;
function QuestionMark({ onClick, pointer = true }) {
    return ((0, jsx_runtime_1.jsx)(QuestionMarkCircle, { onClick: onClick, pointer: pointer, children: "?" }));
}
